<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        cols="2"
        class="pb-0"
      >
        <inventory-class-select-element
          v-model="inventoryClassId"
          :is-state="true"
        />
      </v-col>
      <v-col
        cols="2"
        class="pb-0"
      >
        <v-select
          v-model="filterStatusId"
          label="Status"
          item-text="name"
          item-value="id"
          :items="statuses"
          hide-details="true"
          clearable
        >
          <template #item="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer;"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
          <!-- eslint-disable-next-line vue/no-template-shadow -->
          <template #selection="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer;"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
        </v-select>
      </v-col>
      <v-col
        cols="3"
        class="pb-0"
      >
        <v-autocomplete
          v-model="filterJob"
          label="Job"
          :items="jobCodes"
          hide-details="true"
          item-value="code"
          :item-text="item => `${item.code} - ${item.name}; ${item.reference}`"
          clearable
          :loading="loadingJobs"
        >
          <template #selection="{ item }">
            <span>
              <span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span>
            </span>
          </template>

          <template #item="{ item }">
            <span>
              <span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }}<span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span>
            </span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col
        cols="1"
        class="pb-0"
      >
        <v-autocomplete
          v-model="filterPanelType"
          label="Panel Type"
          item-value="code"
          item-text="code"
          :items="panelTypes"
          hide-details
          clearable
          :loading="loadingPanelTypes"
        />
      </v-col>
      <v-col
        cols="2"
        class="pb-0"
      >
        <v-menu
          ref="menu"
          v-model="dateMenu"
          :return-value.sync="filterDate"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="filterDate"
              label="Date Created"
              readonly
              v-bind="attrs"
              v-on="on"
              @change="$refs.menu.save(filterDate)"
            />
          </template>
          <v-date-picker
            v-model="filterDate"
            no-title
            scrollable
          >
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="menu = false"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="filterDate = null"
            >
              Clear
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row class="align-center">
      <v-col
        cols="auto"
        class="pb-0 pt-0"
      >
        <v-row>
          <v-col>
            <v-tooltip
              top
              color="black"
            >
              <template #activator="{ on }">
                <span
                  :style="{color: isDarkMode ? '#ffffffb3' : '#00000099', fontSize: '16px !important'}"
                  v-on="on"
                >Latest Records</span>
              </template>
              <span>Records from the last 3 months</span>
            </v-tooltip>
          </v-col>
          <v-col
            cols="auto"
            class="pl-0"
          >
            <v-switch
              v-model="switchAll"
              hide-details
              label="All Records"
              class="mt-0 pt-0"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-spacer />
      <!-- <v-col
        cols="auto"
        class="pt-0 pr-0"
      >
        <v-btn
          color="orange"
          outlined
          @click="openHistory()"
        >
          History
        </v-btn>
      </v-col> -->
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="footer"
            :items-per-page="pagination.itemsPerPage"
            :search="search"
            :loading="loading"
            dense
            fixed-header
            :height="windowHeight"
            :server-items-length="total"
            @update:options="updateOptions"
          >
            <template #[`item.inventory_class_id`]="{ item }">
              <v-chip
                small
                :color="item && item.class ? item.class.color : 'black'"
                text-color="white"
              >
                {{ item && item.class ? item.class.name : '' }}
              </v-chip>
            </template>
            <template #[`item.qr_code_value`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.qr_code_value }}
              </text-highlight>
            </template>
            <template #[`item.panel_code`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.panel_code }}
              </text-highlight>
            </template>
            <template #[`item.total_wip_panels`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.total_wip_panels }}
              </text-highlight>
            </template>
            <template #[`item.user_full_name`]="{ item }">
              <span><text-highlight
                :queries="search"
              >{{ item.user_full_name }}</text-highlight></span>
            </template>
            <template #[`item.job`]="{ item }">
              <span>
                <span style="font-weight: bold;"><text-highlight :queries="search">{{ item.job_code ? `${item.job_code}` : '' }}</text-highlight></span> - <text-highlight :queries="search">{{ item.job_name ? item.job_name : item.job_name }}</text-highlight> <span style="color: #1976D2;"><text-highlight :queries="search">{{ item.job_reference ? `; ${item.job_reference}` : '' }}</text-highlight></span>
              </span>
            </template>
            <template #[`item.created_at`]="{ item }">
              <span><text-highlight
                :queries="search"
              >{{ item.created_at }}</text-highlight></span>
            </template>
            <template #[`item.status`]="{ item }">
              <v-chip
                small
                :color="item && item.status ? item.status.color : 'black'"
                text-color="white"
              >
                {{ item && item.status ? item.status.name : '' }}
              </v-chip>
            </template>
            <template #[`item.actions`]="{ item }">
              <v-row>
                <!-- <v-col
                  :class="`pl-1 ${roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdPanelAdmin) ? 'pr-0' : ''} text-end`"
                >
                  <v-tooltip top>
                    <template #activator="{ on }">
                      <v-btn
                        color="success"
                        outlined
                        small
                        v-on="on"
                        @click="viewWIPPanels(item)"
                      >
                        WIP Panels
                      </v-btn>
                    </template>
                    <span>View WIP Panels</span>
                  </v-tooltip>
                </v-col> -->
                <v-col
                  v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdPanelAdmin)"
                >
                  <v-menu offset-y>
                    <template #activator="{ on, attrs }">
                      <v-btn
                        class="mt-1 mb-1"
                        elevation="0"
                        fab
                        outlined
                        x-small
                        v-bind="attrs"
                        tile
                        color="primary"
                        style="border-radius: 7px; width: 28px !important; height: 28px !important;"
                        v-on="on"
                      >
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list
                      class="pa-3"
                    >
                      <v-list-item
                        :disabled="item.status_id !== glassBatchStatusIdNew"
                        @click="softDelete(item.id)"
                      >
                        <v-list-item-title :style="`color: ${item.status_id === glassBatchStatusIdNew ? '#ff5252' : 'rgba(0,0,0,0.26)'}; font-weight: 600;`">
                          <v-row align="center">
                            <v-col
                              cols="auto"
                              class="pr-0 pt-2"
                            >
                              <v-icon
                                color="error"
                                style="font-size: 16px;"
                              >
                                fa-trash
                              </v-icon>
                            </v-col>
                            <v-col>
                              DELETE
                            </v-col>
                          </v-row>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <!-- <v-dialog
      v-model="dialogSourceFile"
      max-width="500px"
      :persistent="true"
    >
      <v-form
        ref="sourceFileForm"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Download CSV Source File</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="downloadSourceFilePoNumber"
                  label="PO#"
                  :rules="[(v) => !!v || 'PO# is required']"
                >
                  <template slot="label">
                    PO#<RedAsterisk />
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="normal"
              class="mr-2"
              @click="dialogSourceFile = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              @click="downloadSourceFilePO()"
            >
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog> -->
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import { saveAs } from 'file-saver';
import { mapState } from 'vuex';
import * as FormatHelpers from '@/helpers/FormatHelpers';

export default {
  components: {
  },
  props: {
    jobCode: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    items: [],
    jobCodes: [],
    statuses: [],
    panelTypes: [],
    selectedLocationId: 0,
    headers: [
      { text: 'Class', value: 'inventory_class_id', align: 'center', width: '3%' },
      { text: 'Batch #', value: 'qr_code_value', width: '8%' },
      { text: 'Job', value: 'job', width: '15%' },
      { text: 'Panel Type/Code', value: 'panel_code', width: '6%' },
      { text: 'Qty', value: 'total_wip_panels', align: 'center', width: '5%' },
      { text: 'Created At', value: 'created_at', width: '8%' },
      { text: 'Created By', value: 'user_full_name', width: '8%' },
      { text: 'Status', value: 'status', width: '10%', align: 'center' },
      { text: 'Actions', value: 'actions', align: 'end', width: '10%', sortable: false },
    ],
    pagination: {
      itemsPerPage: 100,
      page: 1,
    },
    sort: {
      order_by_first: 'id',
      direction_sort: true,
    },
    footer: {
      'items-per-page-options': [20, 50, 100, 500, 1000],
    },
    loading: false,
    inventoryClassId: null,
    filterJob: null,
    dateMenu: false,
    filterDate: null,
    filterStatusId: null,
    filterPanelType: null,
    topSpaceHeight: 270,
    windowHeight: 1000,
    jobLoading: false,
    total: 0,
    dialogCoverSheet: false,
    dialogSourceFile: false,
    loadingJobs: false,
    loadingPanelTypes: false,
    roles: [],
    userRoleIdAdmin: 3,
    userRoleIdAssociate: 6,
    userRoleIdPanelSupervisor: 37,
    userRoleIdPanelAdmin: 38,
    glassBatchStatusIdNew: 1,
    switchAll: false,
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
      wipPanelBatchState: (state) => state.wipPanelBatchState,
      user: (state) => state.user,
      isDarkMode: 'isDarkMode',
    }),
  },
  watch: {
    inventoryClassId() {
      this.get();
    },
    filterJob(value) {
      this.storeState('job_code', value);
      this.get();
    },
    filterStatusId(value) {
      this.storeState('status_id', value);
      this.get();
    },
    filterPanelType(value) {
      this.storeState('panel_code', value);
      this.get();
    },
    filterDate(value) {
      this.$refs.menu.save(value);
      this.storeState('date', value);
      this.get();
    },
    pagination() {
      this.get();
    },
    search() {
      this.get();
    },
    switchAll() {
      this.get();
    },
  },
  created() {
    if (this.jobCode) { this.filterJob = this.jobCode; }
    if (!this.jobCode) {
      if (this.wipPanelBatchState) {
        if (this.wipPanelBatchState.pagination) { this.pagination = this.wipPanelBatchState.pagination; }
        if (this.wipPanelBatchState.job_code) { this.filterJob = this.wipPanelBatchState.job_code; }
        if (this.wipPanelBatchState.status_id !== null) { this.filterStatusId = this.wipPanelBatchState.status_id; }
        if (this.wipPanelBatchState.date) { this.filterDate = this.wipPanelBatchState.date; }
      }
    }
    window.scrollTo(0, document.body.scrollHeight);
    this.windowHeight = window.innerHeight - this.topSpaceHeight;
    this.roles = this.user.roles.map((x) => x.id);
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    init() {
      this.getStatuses();
      this.getJobs();
      this.getPanelTypes();
    },

    storeState(property, value) {
      const state = this.wipPanelBatchState;
      state[property] = value;
      this.$store.commit('storeWipPanelBatchState', state);
    },

    async get() {
      if (this.inventoryClassId === null) return;
      this.loading = true;
      this.items = [];
      this.total = 0;
      const submitModel = {
        filters: {
          inventory_class_id: this.inventoryClassId,
          job_code: this.filterJob,
          panel_code: this.filterPanelType,
          date: this.filterDate,
          status_id: this.filterStatusId,
          is_all: this.switchAll ? 1 : 0,
        },
        pagination: this.pagination,
        search: this.search,
        sort: this.sort,
      };
      const res = await this.$api.wipPanelBatch.readBatches(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      this.loading = false;
      this.init();
      if (!res || !res.data || res.data.length === 0) {
        this.items = [];
        this.total = 0;
        return;
      }
      this.items = res.data;
      this.total = res.total;
    },

    async getJobs() {
      this.loadingJobs = true;
      const submitModel = {
        filters: { inventory_class_id: this.inventoryClassId, is_manual: 0 },
      };
      const res = await this.$api.job.readDDL(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res) {
        this.jobCodes = [];
        this.loadingJobs = false;
        return;
      }
      this.jobCodes = res;
      this.loadingJobs = false;
    },

    async getStatuses() {
      this.statuses = await this.$api.wipPanelBatchStatus.get();
    },

    async getPanelTypes() {
      this.loadingPanelTypes = true;
      this.panelTypes = await this.$api.wipPanelType.get();
      this.loadingPanelTypes = false;
    },

    async softDelete(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      if (!id) return;

      const res = await this.$api.wipPanelBatch.delete(id);

      if (!res) {
        this.$bus.$emit('showError');
        return;
      } else if (typeof res === 'string') {
        this.$bus.$emit('showError', res);
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    openHistory(batchId = null) {
      this.$refs.batchHistoryForm.open(batchId);
    },

    success() {
      this.$bus.$emit('showSuccess');
      this.get();
    },

    // viewWIPPanels(item) {
    //   const typeId = item.type ? item.type.id : null;
    //   const jobCode = item.job ? item.job.code : null;
    //   if (!jobCode || !typeId) {
    //     this.$bus.$emit('showError', 'Job Code or Panel Type is missing.');
    //     return;
    //   }
    //   this.$router.push({
    //     name: 'WipPanelView',
    //     params: {
    //       jobCode: jobCode,
    //       typeId: typeId,
    //     },
    //   });
    // },

    onResize() {
      this.windowHeight = window.innerHeight - this.topSpaceHeight;
    },

    updateOptions(newOptions) {
      // if (newOptions.page !== this.pagination.page || newOptions.itemsPerPage !== this.pagination.itemsPerPage || newOptions.sortBy !== this.pagination.sortBy || newOptions.sortDesc !== this.pagination.sortDesc) {
        this.pagination = newOptions;
        this.sort = {
          order_by_first: newOptions.sortBy[0],
          direction_sort: newOptions.sortDesc[0],
        }
      // }
    },

    async download(item) {
      const csv = await this.$api.glassBatch.get(`download/${item.file_id}`);
      if (!csv) {
        this.$bus.$emit('showError');
        return;
      }
      const file = new Blob([csv], {
        type: 'text/csv',
      });
      saveAs(file, item.file_name);
    },

    async downloadCoverSheet(item) {
      if (!item || !item.cover_sheet_report_path) return;
      const submitData = {
        path: item.cover_sheet_report_path,
      };
      const pdf = await this.$api.glassBatch.store(submitData, 'download-cover-sheet', { responseType: 'blob' });
      if (!pdf) {
        this.$bus.$emit('showError');
        return;
      }
      const now = FormatHelpers.getFileTimestamp();
      const fileName = `${item.batch_number}_Cover_Sheet_Report_${now}`;
      const file = new Blob([pdf], {
        type: 'application/pdf',
      });
      saveAs(file, fileName);
    },

    async createDownloadSourceFile(batch) {
      this.$bus.$emit('loading');
      const res = await this.$api.glassBatch.get(`create-download-source-file/${batch.id}`, { responseType: 'blob' });
      if (!res) {
        this.$bus.$emit('showError');
        this.$bus.$emit('loading');
        return;
      }
      const file = new Blob([res], {
        type: 'text/csv',
      });
      const now = FormatHelpers.getFileTimestamp();
      saveAs(file, `${batch.batch_number}_${now}.csv`);
      this.$bus.$emit('loading');
    },

    async createDownloadCoverSheet(batch) {
      this.$bus.$emit('loading');
      const moduleIdBatchCoverSheet = 34;
      const moduleIdBatchCoverSheetVwd = 35;
      let moduleId = moduleIdBatchCoverSheet;


      moduleId = moduleIdBatchCoverSheet;
      
      const webhookData = {
        id: batch.id,
        batch_number: batch.batch_number,
        module_id: moduleId,
      };
      const res = await this.$api.glassBatch.store(webhookData, 'create-download-cover-sheet', { responseType: 'blob' });
      if (!res) {
        this.$bus.$emit('showError');
        this.$bus.$emit('loading');
        return;
      }
      const now = FormatHelpers.getFileTimestamp();
      const fileName = `${batch.batch_number}_Cover_Sheet_Report_${now}`;
      const file = new Blob([res], {
        type: 'application/pdf',
      });
      saveAs(file, fileName);
      this.$bus.$emit('loading');
    },

  },
};
</script>
<style scoped>
span
{
  font-size: 12px;
}
/* ::v-deep .status-select .v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none !important;
}
::v-deep  .status-select .fa-caret-down:before {
    content: "\f0d7";
    font-size: 16px;
    padding-left: 10px;
} */
::v-deep .v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
    min-height: 20px;
}
::v-deep .fa-caret-down:before {
    font-size: 14px;
}
::v-deep .v-select.v-input--dense .v-select__selection--comma {
    margin: 5px 0 3px 0;
}
.v-application--is-ltr .v-text-field .v-input__append-inner {
    padding-left: 0px !important;
}
::v-deep .v-text-field.v-input--dense .v-input__prepend-inner, .v-text-field.v-input--dense .v-input__append-inner {
    width: 15px;
}
::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    padding-left: 10px;
    padding-right: 10px;
}
::v-deep .v-text-field.v-text-field--solo .v-input__append-inner, .v-text-field.v-text-field--solo .v-input__prepend-inner {
    width: 12px;
}
::v-deep .v-input__icon {
    min-width: 12px;
    width: 12px;
}

::v-deep .select-status .theme--light.v-icon {
    color: white;
}

::v-deep .fa-times-circle:before {
    padding-right: 10px;
}

::v-deep .v-data-table__wrapper {
    overflow-x: hidden !important;
}


</style>
